import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "bonusomat-onboarding__carousel-wrap" }
const _hoisted_2 = { class: "bonusomat-onboarding__footer" }
const _hoisted_3 = { class: "ds-carousel-indicator__dots" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "bottom-slot-action-bar" }
const _hoisted_6 = { class: "bottom-slot-action-bar__wrap" }

import { computed, onMounted, watch } from "vue";

import DsModalDialog from "@sazka/design-system/src/modal-dialog/ds-modal-dialog.vue";
import DsButton from "@sazka/design-system/src/button/ds-button.vue";
import { BonusomatDatalayer } from "@/casino/bonusomat/utils/analytics/bonusomat-datalayer";
import BonusomatOnboardingCarousel from "./bonusomat-onboarding-carousel.vue";

import useBonusomatOnboarding from "../../composables/use-bonusomat-onboarding";


export default /*@__PURE__*/_defineComponent({
  __name: 'bonusomat-onboarding',
  setup(__props) {

const {
    onboardingData,
    onboardingModal,
    onboardingActiveStep,
    onboardingOpenStep,
    openBonusomatOnboarding,
    wasOnboardingAlreadyVisited,
    setOnboardingAlreadyVisited,
} = useBonusomatOnboarding();

let onboardingAnalyticsPushedSteps: number[] = [];

const onboardingPages = computed(() => onboardingData.value?.pages);

const isLastStep = computed(() => onboardingActiveStep.value === onboardingPages.value.length - 1);

onMounted(async () => {
    if (wasOnboardingAlreadyVisited()) return;

    setOnboardingAlreadyVisited();
    await openBonusomatOnboarding("", true);

    BonusomatDatalayer.pushOnboardingImpression(onboardingPages.value[0]?.title, 0);
    onboardingAnalyticsPushedSteps.push(0);
});

watch(onboardingModal, () => {
    if (typeof onboardingModal?.page === "string") {
        const index = onboardingPages.value?.findIndex((page) => page.codeName === onboardingModal?.page);

        onboardingActiveStep.value = index >= 0 ? index : onboardingActiveStep.value;
    }

    if (typeof onboardingModal?.page === "number") {
        onboardingActiveStep.value = onboardingModal?.page;
    }

    onboardingModal.page = null;
});

watch(onboardingActiveStep, (newStep) => {
    if (!onboardingAnalyticsPushedSteps.includes(newStep)) {
        BonusomatDatalayer.pushOnboardingImpression(onboardingData.value.pages[newStep]?.title, newStep);
        onboardingAnalyticsPushedSteps.push(newStep);
    }
});

const stepForward = () => {
    if (onboardingActiveStep.value === onboardingPages.value?.length - 1) return;

    onboardingOpenStep(onboardingActiveStep.value + 1);
};

const stepBack = () => {
    if (onboardingActiveStep.value === 0) return;

    onboardingOpenStep(onboardingActiveStep.value - 1);
};

const changeStep = (step: number) => {
    onboardingOpenStep(step);
};

const closeModalAnalytics = () => {
    BonusomatDatalayer.pushOnboardingClose(
        onboardingData.value.pages[onboardingActiveStep.value]?.title,
        onboardingActiveStep.value
    );
    onboardingAnalyticsPushedSteps = [];
};

const closeModalCtaClick = () => {
    onboardingModal.isOpened = false;
    closeModalAnalytics();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DsModalDialog, {
    modelValue: _unref(onboardingModal).isOpened,
    "onUpdate:modelValue": [
      _cache[0] || (_cache[0] = ($event: any) => ((_unref(onboardingModal).isOpened) = $event)),
      closeModalAnalytics
    ],
    theme: "dark",
    "css-class": "bonusomat-onboarding"
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_unref(onboardingModal).isOpened && _unref(onboardingData))
          ? (_openBlock(), _createBlock(BonusomatOnboardingCarousel, { key: 0 }))
          : _createCommentVNode("", true)
      ])
    ]),
    bottom: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("ol", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(onboardingPages.value, (page, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: page?.codeName,
              class: _normalizeClass(["dot", { 'is-selected': index === _unref(onboardingActiveStep) }]),
              onClick: ($event: any) => (changeStep(index))
            }, null, 10, _hoisted_4))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (_unref(onboardingActiveStep) !== 0)
              ? (_openBlock(), _createBlock(DsButton, {
                  key: 0,
                  type: "secondary",
                  theme: "dark",
                  "icon-left": "chevron-left",
                  onClick: stepBack
                }, {
                  default: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createTextVNode(" Zpět ")
                  ])),
                  _: 1,
                  __: [1]
                }))
              : _createCommentVNode("", true),
            _withDirectives(_createVNode(DsButton, {
              type: "primary",
              theme: "dark",
              "icon-right": "chevron-right",
              onClick: stepForward
            }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createTextVNode(" Další krok ")
              ])),
              _: 1,
              __: [2]
            }, 512), [
              [_vShow, !isLastStep.value]
            ]),
            _withDirectives(_createVNode(DsButton, {
              type: "primary",
              theme: "dark",
              "icon-right": "close",
              onClick: closeModalCtaClick
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createTextVNode(" Zavřít ")
              ])),
              _: 1,
              __: [3]
            }, 512), [
              [_vShow, isLastStep.value]
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})